import { Component } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Router } from '@angular/router';
import { Modal } from 'bootstrap';

@Component({
  selector: 'app-tiene-usuario-yrepro',
  templateUrl: './tiene-usuario-yrepro.component.html',
  styleUrl: './tiene-usuario-yrepro.component.css',
  animations: [
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter, :leave', [
        animate(500)
      ]),
    ]),
  ],
})
export class TieneUsuarioYReproComponent {
  
  mostrarReprocan = false;
  mostrarIdentificacionRepro = false;

  modalInstance: Modal | undefined;

  constructor(private router: Router) {

  }
  
  mostrarSegundaSeccion() {
    this.mostrarReprocan = true;
  }

  irADerivaciones(){
    this.router.navigate(['/derivaciones']);
  }

  irAInscribirse(){
    this.router.navigate(['/inscribirse']);
  }
  
  // openModalConfirmarCodigoRepro() {
  //   const modal = document.getElementById("myModal");
  //   if (modal != null) {
  //     modal.style.display = "block";
  //   }
  // }

  // closeModalConfirmarCodigoRepro() {
  //   const modal = document.getElementById("myModal");
  //   if (modal != null) {
  //     modal.style.display = "none";
  //   }
  // }

  openModalConfirmarCodigoRepro() {
    const modalElement = document.getElementById('myModal');
    if (modalElement) {
      this.modalInstance = new Modal(modalElement);
      this.modalInstance.show();
    }
  }

  closeModalConfirmarCodigoRepro() {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }


  irARegistro() {
    this.closeModalConfirmarCodigoRepro();
    this.router.navigate(['/inscribirse']);
  }

}
